import { render, staticRenderFns } from "./dashboardHeader.vue?vue&type=template&id=04696004&scoped=true"
import script from "./dashboardHeader.vue?vue&type=script&lang=js"
export * from "./dashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./dashboardHeader.vue?vue&type=style&index=0&id=04696004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04696004",
  null
  
)

export default component.exports